<template>
  <div>
      <button :type="nativeType" :disabled="loading" class="btn" :class="{
        [`btn-${type}`]: true,
        'btn-block': block,
        'btn-lg': large,
        'btn-loading': loading
      }">
        <slot/>
          <i :class="ico" v-show="ico" aria-hidden="true" v-if="!loading"></i>
          <i class="fa fa-spinner fa-pulse fa-fw" v-else></i>
      </button>      
  </div>

</template>
<script>

export default {

  name: 'VButton',

  props: {
    type: {
      type: String,
      default: 'primary'
    },

    nativeType: {
      type: String,
      default: 'submit'
    },

    loading: {
      type: Boolean,
      default: false
    },

    ico : null,
    block: Boolean,
    large: Boolean
  },

  computed:{
      icone(){
         if(this.loading == true){
            return 'fa fa-spinner fa-pulse fa-fw'
         }else{
           return this.ico
         }
      }
  }


}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/basicos/Button.vue